import { IconButton, useTheme, keyframes, Backdrop, Paper, FormControlLabel, Button, SxProps, Typography, Stack, Fade, Checkbox } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useEffect, useState } from "react";
import { useAuth, useSchool } from "daymap-react";

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgb(var(--mui-palette-primary-mainChannel) / .9);
  }
  70% {
    box-shadow: 0 0 0 20px rgb(var(--mui-palette-primary-mainChannel) / .0);
  }
  100% {
    box-shadow: 0 0 0 0 rgb(var(--mui-palette-primary-mainChannel) / .0);
  }
`;

export function AttentionMenuButton({ onClick, showBackdrop, setShowBackdrop }: { onClick: () => void, showBackdrop: boolean, setShowBackdrop: (show: boolean) => void }) {
    const [dontShowChecked, setDontShowChecked] = useState(false);
    const theme = useTheme();
    const { Post } = useAuth();
    const { baseUrl } = useSchool();

    useEffect(() => {
        if (!showBackdrop && dontShowChecked) {
            const updateContactProfile = async () => {
                const response = await Post<Response>({ url: `${baseUrl}/lms/api/contact/profilesetting/Portal_HideStudentMenuInfo`, data: 'true', config: { method: 'PATCH' } })
                console.log(response);
            }
            updateContactProfile();
        }
    }, [showBackdrop])


    let buttonProps: SxProps | undefined = !showBackdrop ? undefined : {
        animation: `${pulse} 1.4s infinite`,
        zIndex: theme.zIndex.modal + 1, // ensure it's above backdrop
        position: "relative", // keeps it in flow but layered above
    }

    return (<>
        <IconButton onClick={() => {
            setShowBackdrop(false);
            onClick();
        }} sx={buttonProps}>
            <MenuIcon sx={{ color: theme.palette.getContrastText(theme.palette.background.paper) }} />
        </IconButton>
        <Backdrop open={showBackdrop} sx={{
            zIndex: (theme) => theme.zIndex.modal,
            position: "fixed",
            top: 0,
            left: 0
        }}>
            <Fade in={showBackdrop}>
                <Paper>
                    <Stack gap={2} p={3} maxWidth="85vw">
                        <Typography>Welcome to the new Student Portfolio</Typography>
                        <Typography variant="body2">Use the &nbsp;<MenuIcon fontSize="inherit" />&nbsp; button above to navigate through different pages of student data.</Typography>
                        <Typography variant="body2">Use the nav bar at the bottom of the page to return Home or to non-student specific pages.</Typography>
                        <Stack alignItems="flex-start" display="flex" gap={4} pt={2}>
                            <Typography variant="body2">
                                <FormControlLabel sx={{ fontSize: 'inherit' }} control={<Checkbox checked={dontShowChecked} onChange={(e) => setDontShowChecked(e.target.checked)} sx={{ mr: 1 }} />} label="Don't show me this again" />
                            </Typography>
                            <Button variant="contained" onClick={() => setShowBackdrop(false)}>Got it</Button>
                        </Stack>
                    </Stack>
                </Paper>
            </Fade>
        </Backdrop>
    </>
    );
}